import { SyntheticEvent, KeyboardEvent, useContext } from 'react';
import { SearchStyle, Context as ConfigContext } from '../../Config';
import useSearchWithResultsPage from './useSearchWithResultsPage';
import useSearchWithDropdown from './useSearchWithDropdown';

export type IUseSearch = {
  value: string;
  onChange: (eventOrValue: SyntheticEvent<HTMLInputElement> | string) => void;
  onKeyUp: (e: KeyboardEvent<HTMLInputElement>) => void;
  onSubmit: () => void;

  isOpen: boolean;
  onOpenDropdown: () => void;
  onCloseDropdown: () => void;
  onReset: () => void;
};

function useSearch(): IUseSearch {
  const { searchStyle = SearchStyle.resultsPage } = useContext(ConfigContext);
  // eslint disable because Config won't ever change, so we won't ever change the hook we are returning.
  if (searchStyle !== SearchStyle.resultsPage) return useSearchWithDropdown(); // eslint-disable-line react-hooks/rules-of-hooks
  return useSearchWithResultsPage(); // eslint-disable-line react-hooks/rules-of-hooks
}

export default useSearch;
